import React from 'react';
import { VaultTabKey } from './VaultTabs';
import VaultSopsBody from './VaultSopsBody';
import VaultRisksBody from './VaultRisksBody';
import '../../../components/layout/ModuleLayout.css';

interface VaultNetBodyProps {
  activeTab?: VaultTabKey;
}

const VaultNetBody: React.FC<VaultNetBodyProps> = ({ activeTab = 'sops' }) => {
  const renderPanel = () => {
    switch (activeTab) {
      case 'sops':  return <VaultSopsBody />;
      case 'risks': return <VaultRisksBody />;
      default:      return null;
    }
  };

  return (
    <div className="module-layout">
      <div className="module-main">
        <div className="tab-content">
          <section role="tabpanel" className="tab-panel show">
            {renderPanel()}
          </section>
        </div>
      </div>
    </div>
  );
};

export default VaultNetBody;
